module.exports = __webpack_public_path__ + "static/media/woman-in-black.c497380b.jpg";